export default __webpack_public_path__ + "static/media/emaint.796faccd.png";